import Swiper from 'swiper';
import { Pagination, A11y } from 'swiper/modules';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/a11y'
import domReady from '@src/js/utils/domReady.js'

function testimonialSwiper() {
  new Swiper('.content-block--testimonial-carousel__swiper', {
    modules: [Pagination, A11y],
    slidesPerView: 1,
    spaceBetween: 40,
    centeredSlides: true,
    breakpoints: {
      769: {
        spaceBetween: 80
      },
    },
    a11y: {
      enabled: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    speed: 750,
    loop: true,
    keyboard: {
      enabled: true,
    }
  })
}

domReady(function () {
  testimonialSwiper()
})
